export const mediaSizes = {
  width: {
    tablet1: 601,
    tablet2: 768,
    desktop1: 950,
    desktop2: 1440,
  },
};